const apiUrl = process.env.REACT_APP_API_URL;
export const DeletePreguntaId = async ( id_question : any, id_user : any,
                                        estat : number , id_projecte: string, id_tasca: string, id_practica: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/question/${id_question}/salir`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id_user, estat, id_projecte, id_tasca, id_practica })
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
